import { useEffect, useState } from "react";

export const useValueChanged = (value?: string) => {
  const [isValueChanged, setValueChanged] = useState(false);

  useEffect(() => {
    if (!isValueChanged && value) {
      setValueChanged(true);
    }
  }, [isValueChanged, value]);

  return isValueChanged;
};
